export const environment = {
  production: true,
  apiUrl: 'https://api-aorta.edgardcooper.com/v1',
  resellerUrl: 'https://reseller.edgardcooper.com',
};
